export enum FailedMessagesEndpoint {
  Base = '/data-quality',
  Sc3 = '/sc3',
  Sc4 = '/sc4',
  Search = '/search',
  FailedTransaction = '/failed-transactions',
  Raw = '/raw',
  Exports = '/exports',
  Partners = '/partners',
  Profiles = '/profiles',
  Report = '/report',
  Fields = '/fields',
}
